export interface Shape {
  borderRadius: string;
  buttonRadius: string;
}

export const shape: Shape = {
  borderRadius: '8px',
  buttonRadius: '8px',
};
